// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2PkTG","cell":"ColumnAccessor_cell__19A2P","firstCellAccent":"ColumnAccessor_firstCellAccent__3OVAI"};